/**
 * Take a react-hook-form error subtree (e.g. errors.generalSettings?.location).
 * Return whether it contains at least one error.
 *
 * A populated error node/subtree is always a non-empty object (or a sparse array of them),
 * so its presence with any keys means the corresponding form section has an error.
 */
export const hasFieldError = (error: unknown): boolean => {
  if (error === null || typeof error !== 'object') return false

  return Object.keys(error).length > 0
}
